var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSessionReports = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 2007",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8924_296578)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2005.92,
    transform: "translate(0 0.833984)",
    fill: "#FDCE00"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.833984,
    width: 2000,
    height: 2006,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2858 635.845C71.4193 634.978 70.0143 634.978 69.1478 635.845L55.0266 649.966C54.16 650.833 54.16 652.238 55.0266 653.104C55.8931 653.971 57.2981 653.971 58.1646 653.104L70.7168 640.552L83.269 653.104C84.1355 653.971 85.5405 653.971 86.407 653.104C87.2736 652.238 87.2736 650.833 86.407 649.966L72.2858 635.845ZM70.7168 637.414H68.4979V1359.81H70.7168H72.9357V637.414H70.7168Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M288.903 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M513.461 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M731.509 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M956.063 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1177.36 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1398.67 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1619.97 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1841.27 796.883V1359.9",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1841.27 796.883L70.8573 796.883",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1841.27 979.13L70.8573 979.13",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1841.27 1171.14H70.8573",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950.24 1361.47C1951.1 1360.6 1951.1 1359.2 1950.24 1358.33L1936.11 1344.21C1935.25 1343.34 1933.84 1343.34 1932.98 1344.21C1932.11 1345.08 1932.11 1346.48 1932.98 1347.35L1945.53 1359.9L1932.98 1372.45C1932.11 1373.32 1932.11 1374.72 1932.98 1375.59C1933.84 1376.46 1935.25 1376.46 1936.11 1375.59L1950.24 1361.47ZM1948.67 1359.9V1357.68L70.8562 1357.68V1359.9V1362.12L1948.67 1362.12V1359.9Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.916 1089.57L915.836 1090.27L998.595 1155.43L1006.24 1139.58L1006.41 1139.25C1010 1132.53 1020.19 1134.36 1021.21 1141.92L1021.25 1142.29L1026.75 1201.81L1074.49 1160.95C1077.13 1158.7 1080.92 1158.43 1083.84 1160.26L1084.12 1160.45L1108.4 1177.13L1155.79 1092.87L1160.79 1092.22L1168.75 1086.96L1166.52 1094.87C1166.35 1095.47 1166.11 1096.05 1165.8 1096.6L1116.19 1184.82C1113.91 1188.88 1108.64 1190.1 1104.81 1187.46L1079.81 1170.29L1029.73 1213.15C1024.86 1217.32 1017.3 1214.25 1016.71 1207.86L1011.61 1152.73L1006.67 1162.98C1004.48 1167.53 998.624 1168.89 994.648 1165.76L905.884 1095.86C904.368 1094.67 903.34 1092.96 902.994 1091.06L901.852 1084.79L908.916 1089.57ZM88.0625 1019.63L99.5977 1067.76L141.551 1099.07L170.197 1119.74L208.984 1110.67L209.35 1110.59L209.714 1110.67L215.711 1112.13L243.954 1152.89L257.522 1106.76L263.704 1099.33L264.176 1098.76H329.942L342.413 1082.4L336.324 1100.25C335.231 1103.45 332.22 1105.61 328.834 1105.61H268.861L252.521 1161.16C250.644 1167.54 242.212 1168.9 238.424 1163.43L207.05 1118.16L172.229 1126.3C170 1126.82 167.654 1126.35 165.797 1125.01L137.523 1104.61L137.488 1104.58L137.454 1104.56L95.8105 1073.47C94.328 1072.37 93.279 1070.78 92.8477 1068.98L81.4248 1021.32C81.3187 1020.88 81.2512 1020.43 81.2227 1019.97L71.7686 869.324V810.142L74.9102 810.043L88.0625 1019.63ZM1467.21 1074.2L1471.31 1080.35H1467.28L1435.61 1098.17C1434.95 1098.54 1434.24 1098.81 1433.51 1098.98L1408.07 1104.85L1343.36 1157.11C1340.35 1159.55 1336.01 1159.44 1333.12 1156.85L1250.21 1082.77L1267.53 1084.1L1338.48 1147.49L1401.92 1096.26L1402.27 1095.99C1403.12 1095.38 1404.09 1094.94 1405.11 1094.71L1421.37 1090.95L1434.17 1092.12L1441.96 1084.34L1442.16 1084.14L1442.42 1084.02L1465.25 1073.64L1466.47 1073.09L1467.21 1074.2ZM587.262 1077.78L591.698 1079.7C591.839 1080.29 591.915 1080.9 591.915 1081.54V1142.62L665.84 1112.59L666.11 1112.48L666.392 1112.4L732.258 1093.8L751.535 1092.19L763.76 1087.52L756.504 1096.42C755.477 1097.68 754.086 1098.6 752.521 1099.04L669.539 1122.48L592.255 1153.87C587.051 1155.98 581.362 1152.15 581.362 1146.54V1083.84L566.799 1081.9L586.308 1077.69L586.8 1077.58L587.262 1077.78ZM1931.48 1102.83C1929.18 1104.86 1925.9 1105.38 1923.09 1104.15L1870.62 1081.23L1890.65 1078.46L1925.77 1093.8L1948.84 1073.5H1964.82L1931.48 1102.83ZM2039.46 1084.01L2045.51 1086.64L2042.72 1089.07C2041.88 1089.79 2040.91 1090.33 2039.85 1090.66L2015.07 1098.29C2012.03 1099.22 2008.73 1098.25 2006.69 1095.82L1996.7 1083.95L2012.01 1092.06L2038.37 1083.95L2038.93 1083.78L2039.46 1084.01ZM430.185 1068.16L438.675 1092.41L453.066 1095.82L441.289 1098.32C436.855 1099.26 432.538 1096.29 431.829 1091.82L427.944 1067.29L429.521 1066.26L430.185 1068.16Z",
    fill: "url(#paint0_linear_8924_296578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6279 810.157L91.7393 1019.08L102.887 1065.59L143.698 1096.05L170.996 1115.75L206.395 1107.47L206.691 1107.41C209.762 1106.81 212.909 1108.09 214.701 1110.67L217.06 1114.08L209.954 1112.35C209.552 1112.25 209.133 1112.25 208.73 1112.35L171.028 1121.16C170.285 1121.34 169.503 1121.18 168.884 1120.73L140.61 1100.33L98.9658 1069.25C98.4718 1068.88 98.1222 1068.35 97.9785 1067.75L86.5557 1020.09C86.5203 1019.94 86.4978 1019.79 86.4883 1019.64L73.5176 812.953C73.4222 811.431 74.6331 810.146 76.1582 810.15L78.6279 810.157ZM419.704 1017.36C424.438 1014.52 430.528 1017.28 431.555 1022.65L431.6 1022.91L441.816 1087.42L459.418 1083.68L488.155 1048.34L488.314 1048.15C491.665 1044.27 497.779 1044.57 500.744 1048.74L500.886 1048.95L510.738 1063.76L585.049 1073.69C588.968 1074.22 591.897 1077.55 591.914 1081.5L587.414 1079.56C586.91 1079.34 586.35 1079.29 585.813 1079.41L571.403 1082.51L508.156 1074.06C505.897 1073.76 503.877 1072.5 502.614 1070.6L494.082 1057.78L467.018 1091.07C465.877 1092.47 464.289 1093.44 462.52 1093.82L449.472 1096.58L438.879 1094.07C438.004 1093.86 437.295 1093.22 436.998 1092.37L429.816 1071.86C429.566 1071.14 429.049 1070.62 428.426 1070.33L421.788 1028.42L415.961 1031.93C414.73 1032.67 413.32 1033.06 411.883 1033.06H377.832L352.742 1052.12L340.812 1087.09L331.513 1099.29C331.014 1099.95 330.238 1100.33 329.415 1100.33H266.151C265.367 1100.33 264.623 1100.68 264.122 1101.28L256.403 1110.57L259.295 1100.74L259.394 1100.42C260.479 1097.23 263.487 1095.06 266.888 1095.06H326.946L343.016 1047.95C343.524 1046.46 344.466 1045.15 345.72 1044.2L372.156 1024.12L372.418 1023.93C373.743 1023.01 375.322 1022.51 376.943 1022.51H411.151L419.704 1017.36ZM884.581 992.789C889.21 989.697 895.524 992.251 896.7 997.692L896.753 997.958L913.196 1088.19L918.137 1092.08L909.027 1091.17C908.592 1091.12 908.174 1090.97 907.812 1090.72L902.246 1086.96L887.117 1003.95L844.474 1034.49C843.863 1034.93 843.193 1035.28 842.484 1035.53L791.599 1053.37L761.769 1089.97L752.237 1093.6C752.006 1093.69 751.763 1093.75 751.517 1093.77L724.327 1096.04L748.85 1089.11L783.889 1046.13L784.065 1045.92C784.964 1044.9 786.113 1044.12 787.403 1043.66L838.637 1025.69L884.358 992.943L884.581 992.789ZM1177.15 1018.29C1178.84 1012.94 1185.45 1011.02 1189.75 1014.62L1189.96 1014.79L1269.46 1085.83L1252.14 1084.5L1186.08 1025.48L1168.09 1089.28L1161.87 1093.4C1161.53 1093.62 1161.15 1093.76 1160.75 1093.81L1154.83 1094.58L1156.45 1091.7L1177.07 1018.55L1177.15 1018.29ZM1744.16 1016.14C1745.69 1015.8 1747.29 1015.92 1748.75 1016.49L1749.04 1016.61L1892.91 1079.45L1872.88 1082.21L1745.6 1026.62L1692.27 1038.48L1644 1072.5C1642.66 1073.45 1641.07 1073.95 1639.44 1073.95H1574.04C1573.65 1073.95 1573.27 1073.92 1572.88 1073.87L1546.47 1069.97H1526.75L1486.18 1080.11C1485.55 1080.27 1484.91 1080.35 1484.26 1080.35H1469.42L1467.15 1076.94C1466.43 1075.86 1465.04 1075.47 1463.86 1076L1443.37 1085.32C1443.17 1085.41 1442.98 1085.52 1442.81 1085.66L1433.53 1093.08C1432.99 1093.51 1432.31 1093.72 1431.62 1093.65L1416.24 1092.14L1430.76 1088.78L1462.71 1070.81L1462.94 1070.69C1464.06 1070.1 1465.32 1069.8 1466.59 1069.8H1483.93L1524.51 1059.65L1524.98 1059.55C1525.46 1059.46 1525.94 1059.42 1526.43 1059.42H1546.67C1546.96 1059.42 1547.25 1059.43 1547.53 1059.46L1547.82 1059.5L1574.23 1063.4H1638.6L1686.62 1029.55L1686.95 1029.33C1687.72 1028.84 1688.57 1028.49 1689.46 1028.29L1744.16 1016.14ZM2086.58 1050.93L2044.02 1087.93L2039.79 1085.91C2039.18 1085.62 2038.47 1085.57 2037.82 1085.79L2014.99 1093.4C2014.31 1093.63 2013.56 1093.56 2012.93 1093.23L1997.73 1085.18L1978.07 1061.84L1963.03 1075.07H1947.06L1973.12 1052.13L1973.44 1051.87C1976.66 1049.31 1981.32 1049.66 1984.13 1052.67L1984.41 1052.98L2013.63 1087.69L2036.21 1080.74L2083.12 1039.95C2084.12 1039.08 2085.35 1038.66 2086.58 1038.66V1050.93Z",
    fill: "url(#paint1_linear_8924_296578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3408 810.142L86.5023 1019.87L98.2014 1068.67L140.611 1100.33L169.858 1121.44L209.343 1112.2L247.365 1121.44L264.914 1100.33H304.398H330.721L346.807 1079.23L373.13 1068.67L412.615 1079.23L428.701 1068.67L437.475 1093.74L465.261 1100.33L497.433 1079.23L519.369 1093.74L586.639 1079.23L620.274 1093.74L672.92 1100.33L751.889 1093.74L789.911 1079.23L841.094 1093.74L890.815 1079.23L908.364 1091.1L1000.49 1100.33L1015.12 1091.1L1022.43 1106.93L1079.46 1100.33H1110.17L1161.36 1093.74L1183.29 1079.23L1338.31 1091.1H1405.7L1432.69 1093.74L1443.07 1085.45L1465.9 1075.07L1482.51 1099.98L1526.1 1091.1L1546.86 1079.23L1573.85 1093.74L1640.27 1079.23L1690.09 1085.45L1746.14 1099.98L1926.74 1075.07H1976.56L2011.85 1093.74L2038.83 1085.45L2086.58 1106.93",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 7.47301,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.01 -20.9395C1670 -20.9395 1758.82 -9.05297 1845.3 13.7773C2013.28 58.1036 2172.86 143.808 2301.16 264.442C2423.03 379.027 2516.69 525.222 2562.28 697.337C2563.9 703.45 2562.15 709.964 2557.68 714.436L1594.5 1677.61C1587.57 1684.55 1576.33 1684.55 1569.39 1677.61L970.647 1078.87L606.251 714.47C601.78 709.999 600.025 703.487 601.643 697.375C647.172 525.355 741 379.026 862.759 264.448L862.765 264.443C991.065 143.809 1150.64 58.1037 1318.62 13.7773C1405.14 -9.05291 1493.96 -20.9395 1581.98 -20.9395H1582.01Z",
    stroke: "#655200",
    strokeWidth: 35.503,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8924_296578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2181.36 1066.03C2125.63 958.437 2041.73 867.792 1939.45 803.813C1939.38 803.778 1939.35 803.744 1939.28 803.71L1582.62 1664.77L2181.36 1066.06",
    fill: "#504100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2181.36 1066.03C2125.63 958.437 2041.73 867.792 1939.45 803.813C1939.38 803.778 1939.35 803.744 1939.28 803.71L1582.62 1664.77L2181.36 1066.06",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.62 1664.77V701.668C1713.59 701.668 1835.86 739.049 1939.28 803.678L1582.62 1664.77Z",
    fill: "#473900",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.62 1664.77L1225.96 803.678L1226.13 803.575C1329.54 738.98 1451.71 701.668 1582.62 701.668V703.277V1664.77Z",
    fill: "#3D3100",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.61 1664.77L983.869 1066.03C1039.63 958.368 1123.57 867.655 1225.96 803.71L1582.61 1664.77Z",
    fill: "#3D3100",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1999.69 846.227C2074.8 905.481 2137 980.414 2181.36 1066.03L2545.79 701.598C2501.12 532.973 2409.34 389.611 2289.67 277.092L1999.69 846.227Z",
    fill: "#5B4A00",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.49 718.406L1841.41 30.6592C2006.68 74.2702 2163.64 158.583 2289.64 277.092L1999.67 846.227C1980.39 831.028 1960.3 816.856 1939.45 803.814C1876.64 764.551 1806.91 735.317 1732.49 718.406Z",
    fill: "#504100",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.72 718.405L1323.79 30.6924C1408.89 8.23646 1496.18 -3.43652 1582.62 -3.43652H1582.65C1669.09 -3.43652 1756.34 8.23646 1841.41 30.6924L1732.48 718.44C1684.28 707.486 1634.1 701.7 1582.58 701.7C1531.06 701.7 1480.88 707.486 1432.68 718.44L1432.72 718.405Z",
    fill: "#3D3100",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.54 846.225L875.566 277.125C1001.61 158.615 1158.52 74.3025 1323.79 30.6914L1432.72 718.404C1358.44 735.281 1288.81 764.412 1226.1 803.573C1205.11 816.683 1184.92 830.958 1165.54 846.225Z",
    fill: "#5B4A00",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.565 277.126C756.028 389.611 664.082 533.11 619.479 701.632L983.874 1066.03C1028.24 980.38 1090.44 905.481 1165.54 846.226L875.565 277.126Z",
    fill: "#514200",
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8924_296578",
    x1: 1058.64,
    y1: 810.043,
    x2: 1058.64,
    y2: 1215.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.660069,
    stopColor: "#3E3300",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831731,
    stopColor: "#3E3300",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3300",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8924_296578",
    x1: 1080.04,
    y1: 810.15,
    x2: 1080.04,
    y2: 1121.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.448013,
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721154,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8924_296578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2005.92,
    fill: "white",
    transform: "translate(0 0.833984)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8924_296578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1930.66,
    height: 1701.31,
    fill: "white",
    transform: "translate(616.979 -5.14941)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSessionReports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SessionReports.459437cb82cabf3d1c6d73aa7ec28a1b.svg";